import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom, of } from 'rxjs';
import { catchError, filter, take, timeout } from 'rxjs/operators';
import { selectActor } from '../store/auth/auth.selectors';

export const DeveloperActorGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    const actor = await firstValueFrom(
        store.select(selectActor).pipe(
            filter((a) => a !== null && a !== undefined),
            take(1),
            timeout(3000),
            catchError(() => of(null))
        )
    );

    const roleCode = String(actor?.role_code || '').trim().toLowerCase();
    if (actor?.actor_type !== 'org') return router.parseUrl('/properties');
    if (roleCode === 'subpartner' || roleCode === 'sales') return true;
    if (roleCode === 'app_admin') return router.parseUrl('/admin/dashboard');

    return true;
};
